import React from "react";
import { Container } from "@chakra-ui/react";
import ListBotChannel from "views/admin/BotChannel/components/ListBotChannel";

const BotChannel = () => {
  return (
    <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }}>
      <ListBotChannel />
    </Container>
  );
};

export default BotChannel;
